import {Sugar} from "../../common/utils/sugar";

export class RequestSugarFactory {
    public static produce(): string {
        return Sugar.sugar();
    }
}